// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xCqDrqVrk3RaFvombFZM{flex-direction:column;gap:4px;display:flex}.JD7GtqY7WDESuOMjji18{padding:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sendFrom": `xCqDrqVrk3RaFvombFZM`,
	"textField": `JD7GtqY7WDESuOMjji18`
};
export default ___CSS_LOADER_EXPORT___;
